import { JSX } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Broadcast } from "@/api/broadcast/broadcast.types.ts";
import { ROUTES } from "@/config/routes.ts";
import { cn } from "@/utils/cn.ts";

interface TvCardProps extends Pick<Broadcast, "icon" | "id" | "quality" | "title" | "is_free"> {
  animation?: boolean;
}

const TvCard = ({ title, id, quality, icon, animation = true, is_free }: TvCardProps): JSX.Element => {
  const token = localStorage.getItem("splay:token");

  const link = token ? ROUTES.CHANNELS.SINGLE.replace(":id", id.toString()) : "?modal=auth/login";
  const { t } = useTranslation();

  return (
    <Link to={link} className={"group/card"}>
      <div
        className={cn("relative", {
          "transition-transform xl:group-hover/card:-translate-y-2.5 xl:group-hover/card:transform": !animation,
        })}
      >
        <img
          src={icon}
          alt={title}
          loading={"lazy"}
          className={"aspect-square h-auto w-full rounded-[1rem] bg-gray-300 max-lg:rounded-2xl"}
        />
        <span
          className={cn(
            "absolute -left-1 top-1  rounded-full bg-orange-1 px-2 text-base/normal font-semibold  max-lg:text-[12px]",
            {
              uppercase: !is_free,
            },
          )}
        >
          {is_free ? t("free") : quality}
        </span>
      </div>
    </Link>
  );
};

export default TvCard;
